import request from "@/utils/request";

export function getBase64(url) {
  return request({
    url: url,
    method: "get",
    
  });
}

export function getPaymentInfo(params) {
  return request({
    url: "/api/common/payPlatform/getPayment",
    method: "get",
    params
  });
}